import { sendPublisherWebhookEvents } from "@/lib/utils/publisher";
import { PublisherWebhookEventName, PublisherWebhookEventTypes } from "@/lib/consts/publisher";
import { AuthMethods, LoginResult, DEFAULT_LOGIN_SOURCE } from "@/lib/consts/auth";
import playerService from "@/lib/services/player";
import analyticsService from "@/lib/services/analytics";
import { AnalyticsEventName } from "@/lib/consts/analytics";
import { AuthErrorData } from "@/lib/utils/error";
import { ROUTES } from "@/lib/consts/routes";
import { getCampaignTokenFromUrl } from "./url";
import { getLoginDurationInMs } from "./loginTimer";
export {
    isAppleLogin,
    isFacebookLogin,
    isOTPLogin,
    shouldShowOtpButton,
} from './loginFlow';

export const getLoginSource = (): string => {
    const storedSource = sessionStorage.getItem('source');
    if (storedSource) {
        return storedSource;
    }
    return DEFAULT_LOGIN_SOURCE;
}

const buildLoginWebhookPayload = (baseData: Record<string, unknown>) => {
    const source = getLoginSource();
    
    return {
        source,
        ...baseData,
    };
}

export const sendPostLoginPublisherWebhookEvents = (authMethod: AuthMethods) => {
    const payload = buildLoginWebhookPayload({
        method: authMethod,
        result: LoginResult.SUCCESS,
        ...playerService.getPlayerData(),
        timestamp: new Date().getTime(),
        duration: getLoginDurationInMs(),
    });
    
    sendPublisherWebhookEvents({
        eventType: PublisherWebhookEventTypes.POST_LOGIN,
        eventName: PublisherWebhookEventName.WEBSTORE_LOGIN_COMPLETED,
    }, payload);
}

export const sendLoginFailedPublisherWebhookEvents = (errorData: AuthErrorData) => {
    const payload = buildLoginWebhookPayload({
        ...errorData,
        method: errorData.authMethod,
        result: LoginResult.FAILED,
        duration: getLoginDurationInMs(),
    });
    
    sendPublisherWebhookEvents({
        eventType: PublisherWebhookEventTypes.POST_LOGIN,
        eventName: PublisherWebhookEventName.WEBSTORE_LOGIN_COMPLETED,
    }, payload);
}

export const sendPreLoginPublisherWebhookEvents = () => {
    const isFromCampaign = Boolean(getCampaignTokenFromUrl());
    
    const payload = buildLoginWebhookPayload({
        isFromCampaign,
    });
    
    return sendPublisherWebhookEvents({
        eventName: PublisherWebhookEventName.WEBSTORE_LOGIN_DISPLAYED,
        eventType: PublisherWebhookEventTypes.PRE_LOGIN,
    }, payload);
}

export const sendLoginMethodSelectedWebhookEvents = (method: AuthMethods) => {
    const payload = buildLoginWebhookPayload({ method });

    sendPublisherWebhookEvents({
        eventType: PublisherWebhookEventTypes.PRE_LOGIN,
        eventName: PublisherWebhookEventName.WEBSTORE_LOGIN_METHOD_SELECTED,
    }, payload);

    analyticsService.trackEvent(AnalyticsEventName.LOGIN_CLICKED, { method });
}

export const sendLoginCanceledWebhookEvents = (method: AuthMethods) => {
    const payload = buildLoginWebhookPayload({ method });

    sendPublisherWebhookEvents({
        eventType: PublisherWebhookEventTypes.PRE_LOGIN,
        eventName: PublisherWebhookEventName.WEBSTORE_LOGIN_CANCELED,
    }, payload);

    analyticsService.trackEvent(AnalyticsEventName.LOGIN_CANCELED, { method });
}

export const buildFailedLoginUrl = (errorData: AuthErrorData) => {
    return `${ROUTES.FAILED_LOGIN}?error=auth&message=${encodeURIComponent(errorData.errorMessage)}&authMethod=${encodeURIComponent(errorData.authMethod)}`;
}
